import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  descriptionLabel: 'Description (Optional)',
  nameLabel: 'Name',
})
